/**
 * Maps the potential subscription properties of a cart line item.
 * Theses properties are only available for regular products and contact lenses.
 */ const mapSubscriptionProperties = (serverLineItem)=>{
    var ref, ref1;
    if (serverLineItem.__typename === 'LineItemBundle') {
        return {
            isSubscription: false,
            subscriptionDetails: undefined
        };
    }
    const subscriptionDetails = ((ref = serverLineItem.typeDetails) === null || ref === void 0 ? void 0 : ref.subscriptionDetails) ? {
        deliveryInterval: serverLineItem.typeDetails.subscriptionDetails.deliveryInterval
    } : undefined;
    return {
        isSubscription: ((ref1 = serverLineItem.typeDetails) === null || ref1 === void 0 ? void 0 : ref1.isSubscription) || false,
        subscriptionDetails
    };
};

export { mapSubscriptionProperties };
//# sourceMappingURL=map-subscription-properties.js.map
